// CookieBanner
import React from 'react';

import { connect } from 'react-redux';

import { css, merge } from 'glamor';

import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';

import { WHITE, BLACK, RED } from 'depop/styles/colors';

import { ZINDEX_COOKIE_BANNER } from 'depop/styles/zIndex';

import { FAMILY_STANDARD, FAMILY_EXTENDED_BOLD, } from 'depop/styles/typography';

import Cross from 'depop/components/icons/Cross';

import Container from 'depop/components/layout/Container';

import { closeCookieBanner } from 'depop/state/overlays';

const mapStateToProps = ({ overlays }) => {
  const cookiesAccepted = overlays.cookiesAccepted || false;
  return {
    cookiesAccepted: cookiesAccepted
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeBanner: () => dispatch(closeCookieBanner()),
  };
};

const messages = defineMessages({
  cookiesLinkText: {
    id: 'CookieBanner.linkText',
    defaultMessage: 'cookies',
  },
  cookiesLinkURL: {
    id: 'CookieBanner.linkURL',
    defaultMessage: 'https://depop.zendesk.com/hc/en-gb/articles/115004385847-Cookie-Policy'
  }
});

const defaultBannerMessage = 'Welcome to Depop! By visiting our site you accept the use of {link} which improve the quality of your visit.';

const bannerStyle = {
  position: 'relative',
  zIndex: ZINDEX_COOKIE_BANNER,
  width: '100%',
  backgroundColor: '#f3f3f3',
  color: BLACK,
  textAlign: 'left',
  padding: 15,
  '@media (min-width: 701px)': {
    textAlign: 'center',
    bottom: '36px',
    padding: '15px 30px 15px 54px'
  },
};

const buttonStyle = css({
  width: 24,
  height: 24,
  padding: 4,
  color: 'black',
  cursor: 'pointer',
  ':hover': {
    color: 'white',
  }
});

const placementWrapStyle = {
  display: 'table',
  width: '100%',
};

const placementStyle = css({
  display: 'table-cell',
  verticalAlign: 'middle',
});

const linkStyle = css({
  color: BLACK
});

class CookieBanner extends React.Component {
  props: {
    intl: Object,
    cookiesAccepted: Boolean,
    closeBanner: () => void,
  };

  render() {
    const { intl, closeBanner, cookiesAccepted } = this.props;
    const currentBannerStyle = merge(bannerStyle, { display: cookiesAccepted ? 'none' : 'block'});

    return (
      <div role="alert" {...css(currentBannerStyle)}>
        <div {...css(placementWrapStyle)}>
          <div {...css(placementStyle)}>
            <FormattedMessage
              id="CookieBanner.message"
              defaultMessage={defaultBannerMessage}
              values={{
                link: (
                  <a
                    {...merge(linkStyle)}
                    href={intl.formatMessage(messages.cookiesLinkURL)}
                    rel="noopener"
                    target="_blank">
                    {intl.formatMessage(messages.cookiesLinkText)}
                  </a>
                ),
            }} />
          </div>
          <a {...merge(buttonStyle, placementStyle)}
            href="javascript:;"
            onClick={closeBanner}>
            <Cross />
          </a>
        </div>
      </div>
    );
  }
}

const connectedView = connect(mapStateToProps, mapDispatchToProps)(CookieBanner);

export default injectIntl(connectedView);



// WEBPACK FOOTER //
// ../src/client/components/banners/CookieBanner.js